import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { ErrorChunk } from "container/Error/ErrorChunk";
const ErrorChunkPage = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <ErrorChunk />
    </>
  );
};

export default ErrorChunkPage;
